import { parse } from 'date-fns';

/**
 * If provided with a string, it will transform it to a valid Date instance
 * using the expected format. Note that calling directly new Date(source)
 * will cause the month and day values to be flipped, either causing an
 * invalid date error or giving an incorrect value.
 *
 * @param source - The source value to be converted
 */
export default function adjustToDateInstance(source: Date | string): Date {
  if (source instanceof Date) {
    return source;
  }
  return parse(source, 'dd/MM/yyyy', new Date());
}
